module.exports = __webpack_public_path__ + "img/header-utama.e7831c44.jpg";